import { connect } from 'react-redux';
import GrafikAnalisis from '../../../views/Library/GrafikAnalisis/GrafikAnalisis.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(GrafikAnalisis);
